/* src/app/forms/flow-action/flowaction.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: 10px;
  padding-left: 10px;
  overflow: auto;
}
h3 {
  padding-left: 10px;
}
h1 {
  color: #3f51b5;
  font-size: 1.5em;
  margin-bottom: 15px;
  text-align: center;
}
.mat-mdc-table {
  width: 100%;
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  flex: 1 1 0px;
}
.mat-mdc-form-field {
  width: 100%;
}
button {
  margin: 0 10px;
}
table {
  width: 100%;
  table-layout: fixed;
}
.cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mat-mdc-row,
.mat-mdc-header-row {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}
.mat-mdc-cell,
.mat-mdc-header-cell {
  flex-basis: 0;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-mdc-cell {
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mat-mdc-header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mat-mdc-dialog-actions {
  justify-content: flex-end;
  width: 100%;
}
.btnExec {
  margin-bottom: 10px;
  width: 200px;
}
.progress {
  margin-top: 5px;
  margin-bottom: 5px;
}
.log-area {
  max-height: 200px;
  overflow-y: auto;
}
.log-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  margin-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
}
.detail-log {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.1215686275);
  padding: 4px;
  border-radius: 4px;
}
.log-card {
  margin-bottom: 10px;
}
.flow-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.header-config {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding-top: 10px;
}
.custom-dialog-container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
}
.mat-mdc-card-header {
  padding: 8px 8px 8px;
}
.rounded-icon {
  padding-right: 10px;
}
.status-message {
  padding-left: 10px;
}
/*# sourceMappingURL=flowaction.component.css.map */
